import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { IDispatch, IRootState } from '../../../modules/stores';
import Header from '../Edit/Header';
import BaseInputText from '../Form/Base/InputText';

import { ElementTypes } from '../../../types/element';
import { IConfig } from '../../../types/space';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

interface IProps extends IConnectProps, WrappedComponentProps {}

const EditingAttachment: React.FC<IProps> = ({
  space,
  editingAttachment,
  updateSpaceConfig,
  intl: { formatMessage },
}) => {
  if (space.type !== ElementTypes.FieldRecordRef || !editingAttachment) return null;

  const attachmentHeight = (space.config as IConfig<ElementTypes.FieldRecordRef>).attachmentHeight;

  return (
    <>
      <Header
        spaceType={space.type}
        fieldId={space.fieldId}
        fieldAbsent={!editingAttachment}
      ></Header>
      <BaseInputText
        name="attachmentHeight"
        setFn={(val: string) => {
          updateSpaceConfig({
            id: space.id,
            updates: {
              attachmentHeight: { ...(attachmentHeight ?? {}), [editingAttachment]: Number(val) },
            },
          });
        }}
        title={formatMessage({ id: 'sidebar.attachmentHeight' })}
        type="number"
        value={attachmentHeight?.[editingAttachment] ?? '30'}
      />
    </>
  );
};

const mapState = ({ core, space }: IRootState, { spaceId }: { spaceId: string }) => {
  const currentSpace = space.byId[spaceId];

  return {
    space: currentSpace,
    editingAttachment: space.editingAttachment,
  };
};

const mapDispatch = ({ space }: IDispatch) => ({
  updateSpaceConfig: (payload: any) => space.updateSpaceConfig(payload),
});

export default compose(
  injectIntl,
  connect(
    mapState,
    // @ts-ignore
    mapDispatch,
  ),
)(EditingAttachment);
